import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAPIPublic } from "./tools/api";
import { useEffect } from "react";
import Header from "./components/header";
import { useTheme } from "./context/ThemeContext";
import { Provider } from "react-redux";
import { persistor, store } from "./reducer/store";
import { PersistGate } from "redux-persist/integration/react";
import "./App.scss";
import { MainLayout } from "./components/layouts/layout.jsx";
import { CheckToken, setToken } from "./tools/services";

import { loginRoutes } from "./routes/loginRoutes";
import { dashboardRoutes } from "./routes/dashboardRoutes";
import { simCardPurchaseRoutes } from "./routes/simCardPurchaseRoutes";
import { simCardReplacementRoutes } from "./routes/simCardReplacementRoutes";
import { deliveryAreaRoutes } from "./routes/deliveryAreaRoutes";
import { changeOwnershipRoutes } from "./routes/changeOwnershipRoutes";
import { walletRoutes } from "./routes/walletRoutes";
import { accountRoutes } from "./routes/accountRoutes";
import { dcPurchaseRoutes } from "./routes/dcPurchaseRoutes";
import { payBillRoutes } from "./routes/payBillRoutes";
import { epPurchaseRoutes } from "./routes/epPurchaseRoutes";
import { postCartableRoutes } from "./routes/postCartableRoutes";
import { services360Routes } from "./routes/services360Routes";
import { corporateRoutes } from "./routes/corporateRoutes";
import { creditCardRoutes } from "./routes/creditCardRoutes";
import { bulkRoutes } from "./routes/bulkRoutes";
import { simLockedRoutes } from "./routes/simLockedRoutes.jsx";
import { loginAsRoutes } from "./routes/loginAsRoutes";

export const InitialAPP = () => {
	const { createApiTokenBySession } = useAPIPublic();
	useEffect(() => {
		const callApi = async () => {
			const isTokenValid = await CheckToken();
			if (!isTokenValid) {
				let param = {
					captcha: process.env.REACT_APP_CAPTCHA,
				};
				let responseToken = await createApiTokenBySession(param);
				if (responseToken) {
					await setToken(responseToken);
				}
			}
		};
		callApi();
	}, [createApiTokenBySession]);
};

export const ScrollToTop = () => {
	// Extracts pathname property(key) from an object
	const { pathname } = useLocation();

	// Automatically scrolls to top whenever pathname changes
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
};
function App() {
	const {
		darkMode,
		// setDarkMode,
		rtlMode,
		// setRtlMode
	} = useTheme();

	// const toggleDarkMode = () => setDarkMode((prev) => !prev);
	// const toggleRtlMode = () => setRtlMode((prev) => !prev);
	useEffect(() => {
		// setDarkMode(window.matchMedia("(prefers-color-scheme: dark)").matches);
	}, []);

	return (
		<>
			{/* <InitialAPP /> */}
			<Router>
				<div className="App" data-dark={darkMode} data-dir={rtlMode}>
					<Header />
					<Provider store={store}>
						<PersistGate loading={null} persistor={persistor}>
							<Routes desc="login pages">{loginRoutes}</Routes>
							<Routes desc="global pages">
								<Route
									element={
										<MainLayout>
											<Outlet />
										</MainLayout>
									}>
									{dashboardRoutes}
									{simCardPurchaseRoutes}
									{simCardReplacementRoutes}
									{deliveryAreaRoutes}
									{changeOwnershipRoutes}
									{walletRoutes}
									{accountRoutes}
									{dcPurchaseRoutes}
									{payBillRoutes}
									{epPurchaseRoutes}
									{postCartableRoutes}
									{services360Routes}
									{corporateRoutes}
									{creditCardRoutes}
									{bulkRoutes}
									{simLockedRoutes}
									{loginAsRoutes}
								</Route>
							</Routes>
						</PersistGate>
					</Provider>
				</div>
				<ScrollToTop />
			</Router>
			<ToastContainer />
		</>
	);
}

export default App;
